import React from 'react'
import _ from 'lodash'

import {ActivitySearchItem} from './activitysearchitem.component'

export class ActivitySearchResults extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        var activities = this.props.activities.map(function(act, i) {
            return <ActivitySearchItem
    {...this.props}
    key={i}
    activity={act}
    model="attraction"
    showMe={true}/>
        }, this)

        return (
            <div className="related-content-items">{activities}</div>
        )
    }
}